<tilby-dialog-toolbar
    mat-dialog-title
    [title]="'DIALOG.TRANSLATE_FIELD.TITLE' | translate"
    (confirm)="onSave()"
></tilby-dialog-toolbar>

<tilby-dialog-content>
    <form autocomplete="off" [formGroup]="form">
        <section formArrayName="translations" class="tw-pt-2 tw-px-2 tw-grid">
            @for(translate of translations.controls; track i; let i = $index) {
                <div [formGroupName]="i">
                    <mat-form-field class="tw-w-full">
                        <mat-label>{{ translate.controls.title.value }}</mat-label>
                        <input matInput type="text" formControlName="valueField" 
                            maxlength="255" appTrimInput
                        />
                        <mat-hint [align]="'end'">{{translate.controls.valueField.value?.length || '0'}}
                            / {{data.nameMaxLength}}</mat-hint>
                        @if(translate.controls.valueField.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{data.nameMaxLength}})</mat-error>
                        }
                    </mat-form-field>
                </div>
            }
        </section>
    </form>
</tilby-dialog-content>